import { Component, HostBinding, Input } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "primeng/button";
import * as i2 from "@angular/common";
import * as i3 from "../icon-v2/icon.component";
import * as i4 from "ngx-skeleton-loader";
const _c0 = ["*"];
const _c1 = (a0, a1) => ({
  "with-icon": a0,
  "max-width": a1
});
const _c2 = () => ({
  height: "22px",
  width: "95px",
  "border-radius": "50px"
});
function LinkV2Component_ng_container_0_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 6);
  }
}
function LinkV2Component_ng_container_0_geaui_icon_v2_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "geaui-icon-v2", 7);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("fileSize", 16)("file", ctx_r0.preIcon)("baseUrl", ctx_r0.preIconBaseUrl)("color", ctx_r0.iconColors[ctx_r0.type + (ctx_r0.disabled ? "-disabled" : "")])("hoverColor", ctx_r0.iconColors[ctx_r0.type + "-hover"]);
  }
}
function LinkV2Component_ng_container_0_geaui_icon_v2_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "geaui-icon-v2", 8);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("fileSize", 16)("file", ctx_r0.postIcon)("baseUrl", ctx_r0.postIconBaseUrl)("color", ctx_r0.iconColors[ctx_r0.type + (ctx_r0.disabled ? "-disabled" : "")])("hoverColor", ctx_r0.iconColors[ctx_r0.type + "-hover"]);
  }
}
function LinkV2Component_ng_container_0_span_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 6);
  }
}
function LinkV2Component_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "p-button", 2);
    i0.ɵɵtemplate(2, LinkV2Component_ng_container_0_span_2_Template, 1, 0, "span", 3)(3, LinkV2Component_ng_container_0_geaui_icon_v2_3_Template, 1, 5, "geaui-icon-v2", 4);
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵprojection(5);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, LinkV2Component_ng_container_0_geaui_icon_v2_6_Template, 1, 5, "geaui-icon-v2", 5)(7, LinkV2Component_ng_container_0_span_7_Template, 1, 0, "span", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("styleClass", "gea-link p-button-link p-button-", ctx_r0.types[ctx_r0.type] || "primary", "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(11, _c1, ctx_r0.preIcon || ctx_r0.postIcon, ctx_r0.flex))("disabled", ctx_r0.disabled);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.flex);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.preIcon);
    i0.ɵɵadvance();
    i0.ɵɵclassMapInterpolate1("p-button-content-", ctx_r0.fontWeight, "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.postIcon);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.flex);
  }
}
function LinkV2Component_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ngx-skeleton-loader", 9);
  }
  if (rf & 2) {
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(1, _c2));
  }
}
export class LinkV2Component {
  disabled = false;
  loading = false;
  preIcon = '';
  preIconBaseUrl;
  /**
   * e.g. 16px_arrow-right
   */
  postIcon = '';
  postIconBaseUrl;
  type = 'primary';
  /**
   * the button then stretches to the max width of it's container
   */
  flex = false;
  /**
   * the font weight of the text
   */
  fontWeight = 'bold';
  get pEvents() {
    return this.disabled ? 'none' : 'auto';
  }
  types = {
    primary: 'primary',
    secondary: 'secondary',
    'outlined-link': 'outlined-link',
    'cancel-red': 'cancel-red',
    'white-transparent': 'white-transparent'
  };
  iconColors = {
    primary: 'blue',
    'primary-disabled': 'grey',
    'primary-hover': 'blue',
    secondary: 'black',
    'secondary-disabled': 'grey',
    'secondary-hover': 'grey',
    'outlined-link': 'black',
    'outlined-link-disabled': 'grey',
    'cancel-red': 'cancel-red',
    'white-transparent': 'white'
  };
  static ɵfac = function LinkV2Component_Factory(t) {
    return new (t || LinkV2Component)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: LinkV2Component,
    selectors: [["geaui-link-v2"]],
    hostVars: 2,
    hostBindings: function LinkV2Component_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵstyleProp("pointer-events", ctx.pEvents);
      }
    },
    inputs: {
      disabled: "disabled",
      loading: "loading",
      preIcon: "preIcon",
      preIconBaseUrl: "preIconBaseUrl",
      postIcon: "postIcon",
      postIconBaseUrl: "postIconBaseUrl",
      type: "type",
      flex: "flex",
      fontWeight: "fontWeight"
    },
    ngContentSelectors: _c0,
    decls: 3,
    vars: 2,
    consts: [["skeleton", ""], [4, "ngIf", "ngIfElse"], [3, "ngClass", "disabled", "styleClass"], ["class", "space-maximizer", 4, "ngIf"], ["class", "preIcon", 3, "fileSize", "file", "baseUrl", "color", "hoverColor", 4, "ngIf"], ["class", "postIcon", 3, "fileSize", "file", "baseUrl", "color", "hoverColor", 4, "ngIf"], [1, "space-maximizer"], [1, "preIcon", 3, "fileSize", "file", "baseUrl", "color", "hoverColor"], [1, "postIcon", 3, "fileSize", "file", "baseUrl", "color", "hoverColor"], ["count", "1", "appearance", "line", 3, "theme"]],
    template: function LinkV2Component_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵtemplate(0, LinkV2Component_ng_container_0_Template, 8, 14, "ng-container", 1)(1, LinkV2Component_ng_template_1_Template, 1, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
      }
      if (rf & 2) {
        const skeleton_r2 = i0.ɵɵreference(2);
        i0.ɵɵproperty("ngIf", !ctx.loading)("ngIfElse", skeleton_r2);
      }
    },
    dependencies: [i1.Button, i2.NgClass, i2.NgIf, i3.IconComponent, i4.NgxSkeletonLoaderComponent],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LinkV2Component, [{
    type: Component,
    args: [{
      selector: 'geaui-link-v2',
      template: "<ng-container *ngIf=\"!loading; else skeleton\">\n  <p-button\n    [ngClass]=\"{\n      'with-icon': preIcon || postIcon,\n      'max-width': flex,\n    }\"\n    [disabled]=\"disabled\"\n    styleClass=\"gea-link p-button-link p-button-{{ types[type] || 'primary' }}\">\n    <span class=\"space-maximizer\" *ngIf=\"flex\"></span>\n    <geaui-icon-v2\n      class=\"preIcon\"\n      *ngIf=\"preIcon\"\n      [fileSize]=\"16\"\n      [file]=\"preIcon\"\n      [baseUrl]=\"preIconBaseUrl\"\n      [color]=\"iconColors[type + (disabled ? '-disabled' : '')]\"\n      [hoverColor]=\"iconColors[type + '-hover']\">\n    </geaui-icon-v2>\n\n    <span class=\"p-button-content-{{ fontWeight }}\">\n      <ng-content></ng-content>\n    </span>\n    <geaui-icon-v2\n      class=\"postIcon\"\n      *ngIf=\"postIcon\"\n      [fileSize]=\"16\"\n      [file]=\"postIcon\"\n      [baseUrl]=\"postIconBaseUrl\"\n      [color]=\"iconColors[type + (disabled ? '-disabled' : '')]\"\n      [hoverColor]=\"iconColors[type + '-hover']\">\n    </geaui-icon-v2>\n    <span class=\"space-maximizer\" *ngIf=\"flex\"></span>\n  </p-button>\n</ng-container>\n<ng-template #skeleton>\n  <ngx-skeleton-loader\n    [theme]=\"{ height: '22px', width: '95px', 'border-radius': '50px' }\"\n    count=\"1\"\n    appearance=\"line\"></ngx-skeleton-loader>\n</ng-template>\n"
    }]
  }], null, {
    disabled: [{
      type: Input
    }],
    loading: [{
      type: Input
    }],
    preIcon: [{
      type: Input
    }],
    preIconBaseUrl: [{
      type: Input
    }],
    postIcon: [{
      type: Input
    }],
    postIconBaseUrl: [{
      type: Input
    }],
    type: [{
      type: Input
    }],
    flex: [{
      type: Input
    }],
    fontWeight: [{
      type: Input
    }],
    pEvents: [{
      type: HostBinding,
      args: ['style.pointer-events']
    }]
  });
})();
